
import React, { FC, PropsWithChildren } from 'react';




export const JailBreakProtectedApp : FC<PropsWithChildren> = ({children}) => {



  return ( <>

    {children}
  </>
  );

};
